import { dash } from "radash";

export function formatCurrency(
    amount: number,
    {
        locale = "fr",
        currency = "EUR",
    }: {
        locale?: "fr" | "en";
        currency?: "EUR" | "XPF";
    } = {},
) {
    return amount.toLocaleString(locale, {
        style: "currency",
        currency,
        maximumFractionDigits: currency === "XPF" ? 0 : 2,
        minimumFractionDigits: currency === "XPF" ? 0 : 2,
    });
}

export function removeAccents(string: string) {
    return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function removeHtml(string: string) {
    const div = document.createElement("div");
    div.innerHTML = string;
    return div.textContent || "";
}

/**
 * Remplace les placeholders dans un texte par les données fournies.
 * @param text - Le texte avec des placeholders entre crochets (ex: "[montant_acompte]")
 * @param data - Un objet contenant les valeurs à remplacer (ex: { montant_acompte: "100€" })
 * @returns Le texte avec les placeholders remplacés par les valeurs fournies.
 */
export function replacePlaceholders(text: string, data: Record<string, string>): string {
    return text.replace(/\[([^\]]+)\]/g, (_, key) => data[key] || `[${key}]`);
}

export function slug(string: string) {
    return dash(removeAccents(string));
}

export { capitalize, uid } from "radash";
